import { render, staticRenderFns } from "./activitySubmitAssessment.html?vue&type=template&id=38942a48&external"
import script from "./activitySubmitAssessment.vue?vue&type=script&lang=js"
export * from "./activitySubmitAssessment.vue?vue&type=script&lang=js"
import style0 from "./activitySubmitAssessment.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports